var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"navigation-error fa-stack fa-md",attrs:{"title":_vm.error}},[_c('font-awesome-layers',[_c('font-awesome-icon',{attrs:{"icon":"certificate","size":"2x"}}),_c('font-awesome-icon',{attrs:{"icon":"exclamation"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }